import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

// We can inject some CSS into the DOM.
const styles = {
  contained: {
    background: '#236192',
    borderRadius: 3,
    border: 0,
    minHeight: 32,
    color: 'white',
    padding: '0 30px',
    '&:hover': {
      background: 'linear-gradient(to right, #00d649 0%, #2EC4FF 100%)',
    }
  },
  outlined: {
    background: 'transparent',
    borderRadius: 3,
    border: '1px solid #C5C5C5',
    minHeight: 32,
    color: 'gray',
    padding: '0 30px',
    '&:hover': {
      border: '1px solid linear-gradient(to right, #00d649 0%, #2EC4FF 100%)',
    }
  },
  label: {
    textTransform: 'capitalize',
  },
};

function BaseButton(props) {
  const { classes, children, className, variant, ...other } = props;

  const rootClass = variant === 'contained' 
    ? classNames(classes.contained, className)
    : classNames(classes.outlined, className)

  const styles = {
    root:  rootClass, 
    label: classes.label,
  }

  return (
    <Button classes={styles} {...other}>
      {children || 'class names'}
    </Button>
  );
}

BaseButton.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  variant: PropTypes.string
};

BaseButton.defaultProps = {
  variant: 'contained'
}

export default withStyles(styles)(BaseButton);